export default __webpack_public_path__ + "img/83c3a525b9b006d4a88d1bc40d0ababf.svg";